import { useEffect, useRef, useState } from "react";
import axios from "axios";
import FicheUtilisateurModal, { fmtDateMontreal } from "./FicheUtilisateurModal";
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const PAGE_SIZE = 50;

const th = {
  padding: "6px 10px", fontSize: "11px", fontWeight: "bold", textAlign: "left",
  background: "#d4d0c8", borderBottom: "1px solid #808080", borderRight: "1px solid #e6e3da",
  whiteSpace: "nowrap", position: "sticky", top: 0, zIndex: 1,
};
const td = { padding: "5px 10px", fontSize: "12px", borderBottom: "1px solid #e8e8e8", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" };

export default function GestionUtilisateursModal({ onClose }) {
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [q, setQ] = useState("");
  const [region, setRegion] = useState("");
  const [role, setRole] = useState("");
  const [actif, setActif] = useState("");
  const [regions, setRegions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [ficheUser, setFicheUser] = useState(null);
  const debounceRef = useRef(null);

  const load = (p = page) => {
    setLoading(true);
    axios.get(`${API}/utilisateurs`, {
      params: { q, region, role, actif, page: p, page_size: PAGE_SIZE },
      withCredentials: true,
    })
      .then(r => { setItems(r.data.items || []); setTotal(r.data.total || 0); })
      .catch(() => { setItems([]); setTotal(0); })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    axios.get(`${API}/reference/regions`, { withCredentials: true })
      .then(r => setRegions(r.data || [])).catch(() => {});
  }, []);

  useEffect(() => {
    clearTimeout(debounceRef.current);
    debounceRef.current = setTimeout(() => { setPage(1); load(1); }, 300);
    return () => clearTimeout(debounceRef.current);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [q, region, role, actif]);

  useEffect(() => { load(page); /* eslint-disable-next-line react-hooks/exhaustive-deps */ }, [page]);

  const totalPages = Math.max(1, Math.ceil(total / PAGE_SIZE));

  const regionLabel = (code) => {
    if (!code) return "—";
    const r = regions.find(x => x.code === code);
    return r ? `${code} - ${(r.Description || r.description || "")}` : code;
  };

  return (
    <div className="popup-overlay" onClick={onClose}>
      <div
        className="etab-modal"
        onClick={e => e.stopPropagation()}
        style={{
          maxWidth: 1250, width: "96%", height: "88vh", maxHeight: "88vh",
          display: "flex", flexDirection: "column", overflow: "hidden",
        }}
        data-testid="gestion-utilisateurs-modal"
      >
        <div className="popup-header" style={{ background: "#0033A0", padding: "6px 12px", flexShrink: 0 }}>
          <span className="popup-title">Gestion des utilisateurs</span>
          <button className="win-modal-close" onClick={onClose} data-testid="gestion-users-btn-x">×</button>
        </div>

        {/* Barre de recherche et filtres */}
        <div style={{
          display: "flex", gap: "10px", alignItems: "flex-end", padding: "10px 14px",
          background: "#ece9d8", borderBottom: "1px solid #a0a0a0", flexShrink: 0, flexWrap: "wrap",
        }}>
          <div style={{ flex: "1 1 260px", minWidth: 200 }}>
            <label style={{ fontSize: "11px", fontWeight: "bold", display: "block", marginBottom: "2px" }}>
              Recherche (nom ou courriel)
            </label>
            <input
              className="win-input" data-testid="gestion-users-search"
              value={q} onChange={e => setQ(e.target.value)}
              placeholder="Tapez pour filtrer..."
              style={{ width: "100%" }}
            />
          </div>
          <div>
            <label style={{ fontSize: "11px", fontWeight: "bold", display: "block", marginBottom: "2px" }}>Région</label>
            <select className="win-select" data-testid="gestion-users-filter-region"
                    value={region} onChange={e => setRegion(e.target.value)} style={{ width: 210 }}>
              <option value="">Toutes</option>
              {regions.map(r => (
                <option key={r.code} value={r.code}>
                  {r.code}-{(r.Description || r.description || "").toUpperCase()}
                </option>
              ))}
            </select>
          </div>
          <div>
            <label style={{ fontSize: "11px", fontWeight: "bold", display: "block", marginBottom: "2px" }}>Rôle</label>
            <select className="win-select" data-testid="gestion-users-filter-role"
                    value={role} onChange={e => setRole(e.target.value)} style={{ width: 120 }}>
              <option value="">Tous</option>
              <option value="employe">Employé</option>
              <option value="supprimer">Supprimer</option>
              <option value="jumelage">Jumelage</option>
              <option value="admin">Admin</option>
            </select>
          </div>
          <div>
            <label style={{ fontSize: "11px", fontWeight: "bold", display: "block", marginBottom: "2px" }}>Actif</label>
            <select className="win-select" data-testid="gestion-users-filter-actif"
                    value={actif} onChange={e => setActif(e.target.value)} style={{ width: 90 }}>
              <option value="">Tous</option>
              <option value="1">Oui</option>
              <option value="0">Non</option>
            </select>
          </div>
          <div style={{ marginLeft: "auto", fontSize: "12px", fontWeight: "bold", paddingBottom: "5px" }}
               data-testid="gestion-users-count">
            {total} utilisateur{total > 1 ? "s" : ""}
          </div>
        </div>

        {/* Liste */}
        <div style={{ flex: 1, overflowY: "auto", background: "#fff" }}>
          <table style={{ width: "100%", borderCollapse: "collapse", tableLayout: "fixed" }}
                 data-testid="gestion-users-table">
            <colgroup>
              <col style={{ width: "18%" }} />
              <col style={{ width: "22%" }} />
              <col style={{ width: "18%" }} />
              <col style={{ width: "8%" }} />
              <col style={{ width: "10%" }} />
              <col style={{ width: "6%" }} />
              <col style={{ width: "6%" }} />
              <col style={{ width: "12%" }} />
            </colgroup>
            <thead>
              <tr>
                <th style={th}>Nom</th>
                <th style={th}>Courriel</th>
                <th style={th}>Région</th>
                <th style={th}>Bureau</th>
                <th style={th}>Bureaux suppl.</th>
                <th style={th}>Rôle</th>
                <th style={th}>Actif</th>
                <th style={th}>Dernière connexion</th>
              </tr>
            </thead>
            <tbody>
              {items.map(u => (
                <tr key={u.id}
                    data-testid={`gestion-users-row-${u.id}`}
                    onClick={() => setFicheUser(u)}
                    style={{ cursor: "pointer" }}
                    onMouseEnter={e => e.currentTarget.style.background = "#e8f0fe"}
                    onMouseLeave={e => e.currentTarget.style.background = "transparent"}>
                  <td style={{ ...td, fontWeight: 500 }}>{u.nom_affichage || "—"}</td>
                  <td style={td}>{u.courriel}</td>
                  <td style={td}>{regionLabel(u.region)}</td>
                  <td style={td}>{u.bureau || "—"}</td>
                  <td style={td}>{(u.bureaux || []).filter(c => c !== u.bureau).join(", ") || "—"}</td>
                  <td style={{ ...td, color: (u.roles || []).includes("admin") ? "#b00000" : "inherit", fontWeight: (u.roles || []).includes("admin") ? "bold" : "normal" }}>
                    {(u.roles && u.roles.length ? u.roles.join(", ") : u.role)}
                  </td>
                  <td style={{ ...td, color: u.actif ? "#007000" : "#b00000", fontWeight: "bold" }}>
                    {u.actif ? "Oui" : "Non"}
                  </td>
                  <td style={td}>{fmtDateMontreal(u.derniere_connexion)}</td>
                </tr>
              ))}
              {!loading && items.length === 0 && (
                <tr><td style={td} colSpan={8}>Aucun utilisateur trouvé.</td></tr>
              )}
              {loading && items.length === 0 && (
                <tr><td style={td} colSpan={8}>Chargement...</td></tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        <div style={{
          display: "flex", alignItems: "center", justifyContent: "center", gap: "14px",
          padding: "8px", background: "#ece9d8", borderTop: "1px solid #a0a0a0", flexShrink: 0,
        }}>
          <button className="win-btn-small win-btn" data-testid="gestion-users-prev"
                  disabled={page <= 1} onClick={() => setPage(p => p - 1)}
                  style={{ padding: "2px 12px", fontSize: "12px" }}>
            ◀ Précédent
          </button>
          <span style={{ fontSize: "12px" }} data-testid="gestion-users-page-info">
            Page {page} de {totalPages}
          </span>
          <button className="win-btn-small win-btn" data-testid="gestion-users-next"
                  disabled={page >= totalPages} onClick={() => setPage(p => p + 1)}
                  style={{ padding: "2px 12px", fontSize: "12px" }}>
            Suivant ▶
          </button>
        </div>
      </div>

      {ficheUser && (
        <FicheUtilisateurModal
          user={ficheUser}
          regions={regions}
          onClose={() => setFicheUser(null)}
          onSaved={(updated) => { setFicheUser(updated); load(page); }}
        />
      )}
    </div>
  );
}
